import React, {useState, useRef} from 'react';
import {Button, Image, Input, Form, message, Upload} from "antd";
import './index.css'
import {useSelector} from "react-redux";
import {hyperChatUploadImage} from "../../api/other";

const {TextArea} = Input;
//底部组件
const FooterApp = (props) => {
    const {homePageIndex, handleSend,themeVlue} = props
    const {userInfo, allContextMeta, leftIndex} = useSelector(state => state.user)
    const [form] = Form.useForm();
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [fileList, setFileList] = useState([])
    const [fileList2, setFileList2] = useState([])
    const handleSendTxt = () => {
        if (!userInfo || !allContextMeta) {
            message.error('请先登录！')
            return false
        }
        const {dictionary_meta, analysis_meta, chat_meta, correcting_meta, translating_meta} = allContextMeta
        if (!form.getFieldValue('txt')) {
            message.error('请输入文字后在发送！')
            return false
        }
        let sendValue = {}
        if (homePageIndex === 0) {
            sendValue['scenario'] = 'dictionary'
            sendValue['context_id'] = dictionary_meta.context_id
        } else if (homePageIndex === 1) {
            sendValue['scenario'] = 'translating'
            sendValue['context_id'] = translating_meta.context_id
        } else if (homePageIndex === 2) {
            sendValue['scenario'] = 'correcting'
            sendValue['context_id'] = correcting_meta.context_id
        } else if (homePageIndex === 3) {
            sendValue['scenario'] = 'analysis'
            sendValue['context_id'] = analysis_meta.context_id
        } else if (homePageIndex === 4) {
            sendValue['scenario'] = 'chat'
            sendValue['context_id'] = allContextMeta.chat_meta[parseInt(leftIndex)].context_id

        }
        if (fileList2.length == 0) {
            sendValue['user_content'] = [
                {type: 'text', text: form.getFieldValue('txt')},
            ]
        } else {
            let c = [{type: 'text', text: form.getFieldValue('txt')}]
            fileList2.map(res => {
                c.push({type: "image_url", image_url: {url: res.url}})
            })
            sendValue['user_content'] = c
            setFileList([])
            setFileList2([])
        }
        handleSend(sendValue)
        form.resetFields()
    }

    const uploadRef = useRef(null);
    const propsUpload = {
        beforeUpload: async (file) => {
            if (fileList.length > 5) {
                message.warning('一次性最多上传五张图片')
                return false;
            }
            await hyperChatUploadImage({file}).then(res => {
                if (res.code === 200) {
                    let list = fileList;
                    list.push({uid: list.length, url: res?.data.img_url, index: fileList.length})
                    setFileList([...list])
                    setFileList2([...list])
                }
            })
            return Upload.LIST_IGNORE;
        },
        onRemove: (file) => {
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
        },
        accept: 'image/*',
        isImageUrl: false,
        fileList: fileList,
        onPreview: (file) => {
            setPreviewImage(file.url || file.preview);
            setPreviewOpen(true);
        }
    }
    const propsUpload2 = {
        onRemove: (file) => {
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
            setFileList2(newFileList);
        },
        accept: 'image/*',
        listType: "picture-card",
        fileList: fileList2,
        onPreview: (file) => {
            setPreviewImage(file.url || file.preview);
            setPreviewOpen(true);
        }
    }
	const imageSvg = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
	                        <path d="M4.16667 17.5017C3.70833 17.5017 3.3125 17.342 2.97917 17.0225C2.65972 16.6892 2.5 16.2934 2.5 15.835V4.16838C2.5 3.71004 2.65972 3.32115 2.97917 3.00171C3.3125 2.66838 3.70833 2.50171 4.16667 2.50171H15.8333C16.2917 2.50171 16.6806 2.66838 17 3.00171C17.3333 3.32115 17.5 3.71004 17.5 4.16838V15.835C17.5 16.2934 17.3333 16.6892 17 17.0225C16.6806 17.342 16.2917 17.5017 15.8333 17.5017H4.16667ZM4.16667 15.835H15.8333V4.16838H4.16667V15.835ZM5 14.1684H15L11.875 10.0017L9.375 13.335L7.5 10.835L5 14.1684ZM4.16667 15.835V4.16838V15.835Z" fill="#627900" fill-opacity="0.95"/>
	                       </svg>`
	const footTextSelf = {
	        backgroundColor: themeVlue==='default'?'#fff':'#2c2c2c'
	    }
    return (
        <div className="footerBorder">
            <div className="footerWrap">
                <div className="footerBtn">
                    <Button type="text" style={{width: 40, height: 40, color: '#88993d', padding: '10px'}}>
                        {
                            homePageIndex===4?<Upload {...propsUpload} ref={uploadRef}>
                                <div dangerouslySetInnerHTML={{__html:imageSvg}} style={{display:'inline-block',marginTop:'5px'}}></div>
                            </Upload>:<Image width={20} src={require('../../assets/footer/ai-chat-no-image.png')} preview={false}/>
                        }
                    </Button>
                    <Button type="text" className='footerSend'>
                        <Image onClick={handleSendTxt} width={60} src={require('../../assets/footer/ai-chat-send.png')}
                               preview={false}/>
                    </Button>
                </div>
                <div className={'footerTextarea'}>
                    <div className={'footerTextareaImg'}>
                        <Upload {...propsUpload2} ref={uploadRef}>
                            {/*{fileList.length >= 8 ? null : uploadButton}*/}
                        </Upload>
                        {previewImage && (
                            <Image
                                wrapperStyle={{
                                    display: 'none',
                                }}
                                preview={{
                                    visible: previewOpen,
                                    onVisibleChange: (visible) => setPreviewOpen(visible),
                                    afterOpenChange: (visible) => !visible && setPreviewImage(''),
                                }}
                                src={previewImage}
                            />
                        )}
                    </div>
                    <Form form={form}>
                        <Form.Item label="" name="txt" style={{width: '100%', marginBottom: 0}}>
                            <TextArea style={footTextSelf} className={`footText`} placeholder="请输入" autoSize={{minRows: 4, maxRows: 4,}}/>
                        </Form.Item>
                    </Form>
                </div>

            </div>
        </div>
    )
}
export default FooterApp
